module.exports = __webpack_public_path__ + "img/draw-a.cefde005.png";